// extracted by mini-css-extract-plugin
export default {"formDiv":"styles_formDiv__0aP0k","inputText":"styles_inputText__F-57f","forgetLink":"styles_forgetLink__3sAb-"};